export default "__VITE_ASSET__jfd7C_3v__"